/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "lib/commons/registry";

const r = REG.reg;
r.newPerm("DO", null, 0);
r.newPerm("DATA", null, 0);
r.newPerm("deploy", "DO", 0);
r.newPerm("use", "DO", 0);
r.newPerm("admin", "DO", 0);
r.newPerm("adminSyst", "DO", 0);
r.newPerm("read", "DO", 1);
r.newPerm("write", "DO", 0);
